module.exports = __webpack_public_path__ + "img/graphs.d0167a36.svg";